import styled from 'styled-components';

export const Container = styled.div`
  max-width: 966px;
  margin: 0 auto;
  width: 100%;
  margin-bottom: 12px;
`;
